import { globalStyle, style } from "@vanilla-extract/css";

/** Hover and tab target for a disabled dropdown's tooltip. Sizes like the
 *  trigger it wraps, so a `SelectGroup` row keeps its equal-width columns, and
 *  repeats the disabled cursor the trigger can no longer show. */
export const disabledWrap = style({
  display: "inline-flex",
  width: "100%",
  minWidth: 0,
  cursor: "default"
});

globalStyle(`${disabledWrap} > *`, {
  pointerEvents: "none"
});
